import * as Yup from "yup";

export const LogInSchema = Yup.object({

    username: Yup.string().required("Enter Your Username"),
    password: Yup.string().required("Enter Your Password"),
    role: Yup.string().required("Select Role"),
});